import {REJECTED_DATA_ACTION} from '../../../actionType';

export default function (state={},action){
    switch (action.type) {
        case REJECTED_DATA_ACTION:
            return {
                ...state,
                rejectedData: action.rejectedData,
            };
        default:
            return state;
    }
}
